import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=0bfba517&"
import script from "./CarList.vue?vue&type=script&lang=js&"
export * from "./CarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports